import CustosGeraisProjetoView from "../../components/gestaoOrcamentaria/CustosGeraisProjetoView";

export default function CustosGeraisProjeto() {
  return <CustosGeraisProjetoView tituloModulo="Custos Gerais por Projeto" />;
}
